import React from "react";
import "./button.scss";

export const Button = (props: ButtonTypes) => {
  let content: JSX.Element = <></>;
  if (props.text && props.icon) {
    content = (
      <>
        <div className="text">{props.text}</div>
        <div className="icon">{props.icon}</div>
      </>
    );
  } else if (props.text) {
    content = <div className="text">{props.text}</div>;
  } else if (props.icon) {
    content = <div className="icon">{props.icon}</div>;
  } else {
    content = <div className="no-content">provide some content!</div>;
  }
  return (
    <button className={"btn " + props.classNames} onClick={props.onClick ? () => props.onClick!() : undefined}>
      {content}
    </button>
  );
};

type ButtonTypes = {
  text?: string;
  icon?: JSX.Element;
  color?: string;
  classNames?: string;
  onClick?: Function;
};
